/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}            from '@/util/i.command';
import {TSOEditor}           from './t.s.o.editor';

/**
 *
 * @class SetDescriptionCommand
 *
 * @brief reversible updates of the description column
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetDescriptionCommand implements ICommand {

  private oldValue: string;
  private newValue: string;
  private editor:   TSOEditor;

  constructor(oldValue: string, newValue: string, editor: TSOEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setDescription(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setDescription(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[desc] ' + this.oldValue + ' => ' + this.newValue;
  }

}
